// @flow
import React, { Component } from 'react';
import EventCardList from 'components/common/EventCardList/EventCardList';
import type { State } from 'store';
import { EventingActions } from 'store/actionCreators';
import type { EventItem } from 'store/modules/eventing';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type Props = {
  events: ?(EventItem[]),
  prefetched: ?(EventItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class TrendingEventCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { events, prefetching, loading } = this.props;
    if (!events || events.length === 0 || prefetching || loading) return;
    const lastId = events[events.length - 1].id;
    if (this.props.prefetched) {
      EventingActions.revealPrefetched('trending');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await EventingActions.prefetchTrendingEvents(
        (this.props.events && this.props.events.length) || 0,
      );
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    // this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { shouldCancel, events } = this.props;
    if (events && events.length > 0) {
      // do not fetch event data when already exists
      return;
    }
    try {
      if (!shouldCancel) {
        await EventingActions.getTrendingEvents();
      }
      // this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  componentDidMount() {
    this.initialize();
    // this.listenScroll();
  }

  componentWillUnmount() {
    // this.unlistenScroll();
  }

  render() {
    const { events } = this.props;
    if (!events) return false;
    const filterEvents = events.filter(event => event.meta && !event.meta.eventStatus);
    return (
      <EventCardList
        events={filterEvents}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
        isTrending
      />
    );
  }
}

const mapStateToProps = ({ eventing, pender, base, common }: State) => ({
  events: eventing.trending.events,
  prefetched: eventing.trending.prefetched,
  prefetching: pender.pending['eventing/PREFETCH_TRENDING_EVENTS'],
  loading: pender.pending['eventing/GET_TRENDING_EVENTS'],
  width: base.windowWidth || 1600,
  hasEnded: eventing.trending.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(TrendingEventCards);



// WEBPACK FOOTER //
// ./src/containers/list/TrendingEventCards.js